window.addEventListener('load', () => {
    // cache elements
    const origin = document.querySelector<HTMLElement>('.header-origin');
    const box = origin?.querySelector<HTMLElement>('.header-box');
    const header = box?.querySelector<HTMLElement>('.header-component');
    if (!origin || !box || !header) return;

    // initial header height
    let headerH = header.getBoundingClientRect().height;
    origin.style.maxHeight = `${headerH}px`;

    // states
    let lastScroll = window.scrollY;
    let lastDown = true;
    let lastBoxH = box.offsetHeight;

    let ticking = false;
    let latestScroll = lastScroll;

    const onFrame = () => {
        ticking = false;
        const curScroll = latestScroll;
        const curDown = curScroll > lastScroll;

        let newH = lastBoxH;

        // adjust box height based on scroll movement
        if ((curDown || (!curDown && lastDown)) && lastBoxH <= curScroll) {
            newH = curScroll;
        } else if (curDown && !lastDown && (lastBoxH < curScroll || lastBoxH > curScroll + headerH)) {
            newH = curScroll + headerH;
        }

        // apply updated height
        if (newH !== lastBoxH) {
            box.style.height = `${newH}px`;
            lastBoxH = newH;
        }

        lastScroll = curScroll;
        lastDown = curDown;
    };

    window.addEventListener('scroll', () => {
        latestScroll = window.scrollY;
        if (!ticking) {
            ticking = true;
            // sync update to next frame
            requestAnimationFrame(onFrame);
        }
    }, {passive: true});

    // recalc header height on resize
    window.addEventListener('resize', () => {
        headerH = header.getBoundingClientRect().height;
        origin.style.maxHeight = `${headerH}px`;
    });
});
